import styled from 'styled-components';
import { Typography } from '~components';
import { Link as LinkComponent } from '~components';
import { StyledLinkProps } from './types';

export const Terms = styled(Typography).attrs({
  as: 'p',
})`
  color: ${({ theme }) => theme.color.text.neutral.default};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`;

export const Link = styled(LinkComponent)<StyledLinkProps>`
  &:hover {
    cursor: ${({ $cursor }) => ($cursor ? 'wait' : 'pointer')};
  }
`;
